import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  UrlTree,
} from '@angular/router';
import {
  CompanyModuleService,
  CompanyToolsService,
} from '@web-frontend/shared/services/company';
import { Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CompanyModuleGuard implements CanLoad, CanActivate {
  constructor(
    private companyModuleService: CompanyModuleService,
    private companyToolsService: CompanyToolsService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this._check(route.data);
  }

  canLoad(route: Route): Observable<boolean | UrlTree> {
    return this._check(route.data);
  }

  private _check(
    data: Record<string, unknown> = {}
  ): Observable<boolean | UrlTree> {
    const modules: string[] = (data['modules'] as string[]) ?? [];
    const tools: string[] = (data['tools'] as string[]) ?? [];

    if (tools.length > 0) {
      return this.companyToolsService.activeTools$.pipe(
        filter((activeTools) => activeTools !== null),
        take(1),
        map((activeTools) =>
          activeTools.some((activeTool) => tools.includes(activeTool.id))
        ),
        tap((res) => {
          if (!res) {
            this.companyModuleService.goFirstRouteActive();
          }
        })
      );
    }

    return this.companyModuleService.activeModules$.pipe(
      filter((activeModules) => activeModules !== null),
      take(1),
      map((activeModules) =>
        activeModules.some((activeModule) => modules.includes(activeModule.id))
      ),
      tap((res) => {
        if (!res) {
          this.companyModuleService.goFirstRouteActive();
        }
      })
    );
  }
}
